
// all slider
window.SplideSliderFunction = function () {
  document.querySelectorAll('.splide').forEach((element) => {
    const perPage = parseInt(element.dataset.perPage) || 1;
    const gap = element.dataset.gap || '24px';
    const drag = element.dataset.drag === 'true';
    const arrows = element.dataset.arrows === 'true';
    const direction = element.dataset.direction;
    const height = element.dataset.height;
    const autoplay = element.dataset.autoplay === 'true';
    const autoplayintervel = parseInt(element.dataset.autoplayintervel);
    const type = element.dataset.type;
    const paginatione = element.dataset.pagination == 'true';

   
    const splide = new Splide(element, {
      type: type,
      perPage: perPage,
      arrows: arrows,
      pagination: paginatione,
      drag: drag,
      autoplay: autoplay,
      gap: gap,
      interval: autoplayintervel || 3000,
      breakpoints: {
        989: {
          pagination: paginatione,
          drag: true,
          perPage: 2,
          gap: "20px"
        },
        767: {
          perPage: 2,
          arrows: arrows,
          pagination: paginatione,
        },
        575: {
          perPage: 1,
          arrows: arrows,
          pagination: paginatione
        }
      }
    });



splide.mount();
    
    
  });
  
};

SplideSliderFunction();


// document.querySelector('INSERT-SELECTOR-HERE').addEventListener('click', () => {
//   Rebuy.SmartCart.show();
// });
